import request from '@/plugins/axios'
//合同归档
// 合同归档-查询
export function queryContractReceivePaymentFilingApi(data) {
    return request({
        url: '/contractReceivePaymentFiling/v1.0.0/page',
        method: 'post',
        data
    })
}
// 合同归档-新增
export function addContractReceivePaymentFilingApi(data) {
    return request({
        url: '/contractReceivePaymentFiling/v1.0.0/add',
        method: 'post',
        data
    })
}
// 合同归档-修改
export function editContractReceivePaymentFilingApi(data) {
    return request({
        url: '/contractReceivePaymentFiling/v1.0.0/update',
        method: 'post',
        data
    })
}
// 合同归档-详情
export function queryContractReceivePaymentFilingDetailsApi(data) {
    return request({
        url: '/contractReceivePaymentFiling/v1.0.0/detail',
        method: 'post',
        data
    })
}
// 合同归档-删除
export function deleteContractReceivePaymentFilingApi(data) {
    return request({
        url: '/contractReceivePaymentFiling/v1.0.0/delete',
        method: 'post',
        data
    })
}
// 获取已通过合同并未归档的合同列表
export function queryListJsonForFillingApi(data) {
    return request({
        url: '/contractReceivePayment/v1.0.0/listJsonForFilling',
        method: 'post',
        data
    })
}